import React, { Component } from 'react';
import Select from 'react-select';
import './form.css';
import { toast } from 'react-toastify';
import {
  allLocationWithShortName,
  dataUser,
  spocLocationDetailsZoho,
} from '../Helpers/util';
import axiosInstance from '../../utils/axiosInstance';
import $ from 'jquery';
import axios from 'axios';
import SwInput from '../Common/FormComponent/SwInput';
import SwSelect from '../Common/SwReactSelect/SwReactSelect';
import SwRadio from '../Common/FormComponent/SwRadio';
import AntDDatePicker from '../Common/AntDDateTimePicker/AntDDatePicker';
import dayjs from "dayjs";

const userDataLocal = dataUser();
const UserObj = JSON.parse(userDataLocal);
const userDataLocal12 = spocLocationDetailsZoho();
const locationWithShortName = allLocationWithShortName();

class ParkingSlots extends Component {
  state = {
    locationError: '',
    location2: '',
    carError: '',
    bikeError: '',
    dateError: '',
    date1Error: '',
    pax: '',
    pax1: null,
    location: '',
    location1: '',
    locationSpoc: [],
    locationData: [],
    floorSpoc: [],
    locationNew: [],
    locationId: null,
    floorId: null,
    purpose: '',
    notes: '',
    budget: '',
    company_id: UserObj ? UserObj.company_id : null,
    userid: UserObj ? UserObj.rec_id : null,
    email: UserObj ? UserObj.email : null,
    fb: '',
    date: '',
    date1: '',
    func: [{ fandb: 'lunch', bgt: '1' }, { fandb: 'snack', bgt: '2' }],
    btnStatus: false,
    car_parking_slots: 0,
    bike_parking_slots: 0,
    car_parking_slots_fix: 0,
    bike_parking_slots_fix: 0,
    selectedOption: 'No',
    selectedVehicleType: '',
    selectedOptionError: '',
    selectedVehicleTypeError: '',
    fixedSlotsError: '',
  };

  changeSelect = e => {
    this.setState({
      location: e?.label || '',
      location1: e?.label || '',
      locationId: e?.value || null,
      locationError: '',
    });
  };

  onPaxChange = e => {
    const fieldValue = parseFloat(e.target.value);
    this.setState(
      {
        pax: fieldValue,
        carError: '',
      },
      this.calculateDifference,
    );
  };

  onPaxChange1 = e => {
    this.setState({
      pax1: e?.target?.value || null,
      bikeError: '',
    });
  };

  onFirstSlotChange = e => {
    const value = parseFloat(e?.target?.value) || 0;
    this.setState({
      car_parking_slots: value,
      bike_parking_slots: value,
    });
  };

  onFixedSlotChange = e => {
    const fieldValue = parseFloat(e.target.value) || 0;
    if (fieldValue > this.state.pax) {
      this.setState({
        fixedSlotsError:
          'Fixed slots cannot be greater than additional parking slots.',
      });
    } else {
      this.setState(
        {
          fixedSlotsError: '',
          car_parking_slots_fix: fieldValue,
          bike_parking_slots_fix: fieldValue,
        },
        this.calculateDifference,
      );
    }
  };

  calculateDifference = () => {
    if (this.state.selectedVehicleType === 'Car') {
      const { pax, car_parking_slots_fix } = this.state;
      const car_parking_slots = pax - car_parking_slots_fix;
      this.setState({ car_parking_slots });
    } else {
      const { pax, bike_parking_slots_fix } = this.state;
      const bike_parking_slots = pax - bike_parking_slots_fix;
      this.setState({ bike_parking_slots });
    }
  };

  onDateChange = (date) => {
    this.setState({
      date,
      dateError: '',
      date1: null,      // reset end date when start date changes
      date1Error: '',
    });
  };


  onDateChange1 = (date) => {
    if (!this.state.date) {
      this.setState({ date1Error: '' });
      toast.error('Please select start date before selecting end date.');
      return;
    }

    if (date && date.isBefore(this.state.date, 'day')) {
      this.setState({ date1Error: 'End date cannot be before start date' });
      toast.error('End date cannot be before start date');
      return;
    }

    this.setState({
      date1: date,
      date1Error: '',
    });
  };


  onNotes = e => {
    this.setState({
      notes: e?.target?.value || '',
      noteError: '',
    });
  };

  componentDidMount() {
    this.fetchLocations();
    const LocationSpoc = JSON.parse(userDataLocal12);
    const locationShort = JSON.parse(locationWithShortName);
    this.setState({ locationNew: locationShort });
  }

  handleOptionChange = event => {
    this.setState({
      selectedOption: event.target.value,
      selectedOptionError: '',
    });
  };

  handleOptionChangeVehicleType = event => {
    this.setState({
      selectedVehicleType: event.target.value,
      selectedVehicleTypeError: '',
    });
  };

  fetchLocations = async () => {
    try {
      let authToken = JSON.parse(localStorage.getItem('headData'));
      const axiosConfig = {
        params: {
          spoc: UserObj?.rec_id,
          client: UserObj.company_id,
        },
        headers: {
          Authorization: `${authToken?.spintlyToken}`,
        },
      };
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}basic-data/get-centers-by-spoc`,
        axiosConfig,
      );
      if (response.data.status === 'success') {
        this.setState({ locationSpoc: response.data.data });
      }
    } catch (error) {
      console.error('Error fetching locations:', error);
    }
  };

  floorData = async locationId => {
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/tickets/get-floorv2`,
        {
          params: { location: locationId },
        },
      );
      if (response.data.status === 'success') {
        this.setState({ floorSpoc: response.data.data });
      }
    } catch (error) {
      console.error('Error fetching floors:', error);
    }
  };

  categoryData = async locationId => {

    // Add category API logic here
  };

  handleLocationChange = async selectedOption => {
    this.setState(
      {
        location1: selectedOption?.label || '',
        locationId: selectedOption?.value || null,
        locationError: selectedOption ? '' : "Location can't be empty",
        location2: null,
        floorSpoc: [],
        floorId: null,
      },
      async () => {
        if (selectedOption) {
          await this.floorData(selectedOption.value);
        }
      },
    );
  };

  handleFloorChange = async selectedOption => {
    this.setState(
      {
        location2: selectedOption,
        floorId: selectedOption?.value || null,
        floorError: selectedOption ? '' : "Floor Name can't be empty",
      },
      async () => {
        if (selectedOption) {
          await this.categoryData(this.state.locationId);
        }
      },
    );
  };

  handleSubmit = async e => {
    e.preventDefault();


    // Validation checks
    if (!this.state.location1) {
      this.setState({ locationError: "Location can't be empty" });
      return;
    }
    if (!this.state.floorId) {
      this.setState({ floorError: "Floor can't be empty" });
      return;
    }
    if (!this.state.selectedVehicleType) {
      this.setState({ selectedVehicleTypeError: 'Please select at least one' });
      return;
    }
    if (this.state.pax === null || this.state.pax < 0) {
      this.setState({
        carError: "No. of additional parking slots can't be empty or negative",
      });
      return;
    }
    if (!this.state.date) {
      this.setState({ dateError: "Start date can't be empty" });
      return;
    }
    if (!this.state.date1) {
      this.setState({ date1Error: "End date can't be empty" });
      return;
    }
    if (new Date(this.state.date1) < new Date(this.state.date)) {
      this.setState({
        date1Error: 'End date cannot be earlier than start date',
      });
      return;
    }

    this.setState({ btnStatus: true });
    e.currentTarget.disabled = true;

    try {
      const requestData = {
        locationCode: this.state.locationId,
        category: 'Additional Parking',
        subCategory: 'Service Request',
        subject: 'Parking',
        userId: UserObj ? String(UserObj.rec_id) : '',
        description: 'Parking Request',
        userName: UserObj ? `${UserObj.fname} ${UserObj.lname}` : '',
        email: UserObj ? UserObj.email : '',
        phone: UserObj ? UserObj.phone : '',
        companyId: UserObj ? String(UserObj.company_id) : '',
        companyName: UserObj ? UserObj.company_name : '',
        floor: String(this.state.floorId),
        ticketType: 'service-request',

        formInfo: {
          // locationName: this.state.location1,
          vehicleType: this.state.selectedVehicleType,
          additionalParkingCount: this.state.pax,
          startDate: this.state.date,
          endDate: this.state.date1,
          // category: 'Additional Parking',
          // subCategory: 'Service Request',
          // floorId: this.state.floorId,
        },
      };

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_GATEWAYS_URL
        }cspoc/api/v2/tickets/addTicket`,
        requestData,
        {},
      );
      toast.success('Request is submitted successfully', {});
      this.resetValue();
      setTimeout(() => {
        this.props.onClose?.();
      }, 1000);
    } catch (error) {
      console.error('Error creating ticket:', error.response || error.message);
      toast.error('Failed to create ticket. Please try again.');
    } finally {

      this.setState({ btnStatus: false });
      // e.currentTarget.disabled = false;
    }
  };

  resetValue = () => {
    this.setState({
      pax: 0,
      pax1: null,
      notes: '',
      location: '',
      location1: '',
      location2: null,
      locationId: null,
      floorId: null,
      date: '',
      date1: '',
      locationError: '',
      floorError: '',
      carError: '',
      bikeError: '',
      dateError: '',
      date1Error: '',
      selectedOption: 'No',
      selectedVehicleType: '',
      selectedOptionError: '',
      selectedVehicleTypeError: '',
      car_parking_slots: 0,
      bike_parking_slots: 0,
      car_parking_slots_fix: 0,
      bike_parking_slots_fix: 0,
      fixedSlotsError: '',
    });
  };

  render() {
    const { selectedOption, selectedVehicleType } = this.state;

    return (
      <>

        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>
                Location <span className="Required">*</span>
              </label>
              <SwSelect
                value={
                  this.state.location1
                    ? {
                      value: this.state.locationId,
                      label: this.state.location1,
                    }
                    : null
                }
                onChange={this.handleLocationChange}
                options={this.state.locationSpoc?.map(item => ({
                  value: item.centercode,
                  label: item.location_name,
                }))}
                id="park-request-location-select"
                isClearable={false}
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.locationError}
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>
                Floor <span className="Required">*</span>
              </label>
              <SwSelect
                value={this.state.location2}
                onChange={this.handleFloorChange}
                options={this.state.floorSpoc?.map(item => ({
                  value: item.rec_id,
                  label: item.business_name,
                }))}
                id="park-request-floor-select"
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.floorError}
              </span>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12">
            <div className="d-flex mb-3">
              <div className="Image_radio_container">
                <SwRadio
                  id="CarPark_Sl"
                  name="Parkcheck"
                  value="Car"
                  checked={selectedVehicleType === "Car"}
                  onChange={this.handleOptionChangeVehicleType}
                  label={
                    <span className="btn btn-default">
                      <img src="img/Parking-Car-Icon.svg" alt="Car" />
                    </span>
                  }
                />
              </div>

              <div className="Image_radio_container">
                <SwRadio
                  id="BikePark_Sl"
                  name="Parkcheck"
                  value="Bike"
                  checked={selectedVehicleType === "Bike"}
                  onChange={this.handleOptionChangeVehicleType}
                  label={
                    <span className="btn btn-default">
                      <img src="img/Parking-Bike-Icon.svg" alt="Bike" />
                    </span>
                  }
                />
              </div>
            </div>

            <span className="SwTextDanger SwTextSmall">
              {this.state.selectedVehicleTypeError}
            </span>
          </div>
        </div>
        <div className="row">
          <div className="col-12 pr-2">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>No of Additional Parking Slots</label>
              <SwInput
                type="number"
                value={this.state.pax}
                onChange={this.onPaxChange}
                placeholder="Enter Number of Slots"
                min="0"
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.carError}
              </span>
            </div>
          </div>
        </div>
        <div className="row event">
          <div className="col-md-6 pr-2">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>
                Service Start Date
                <span className="Required">*</span>
              </label>
              <AntDDatePicker
                value={this.state.date ? dayjs(this.state.date) : null}
                onChange={this.onDateChange}
                allowClear={false}
                placeholder="Start Date"
                disabledDate={(current) =>
                  current && current < dayjs().startOf("day")
                }
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.dateError}
              </span>
            </div>
          </div>
          <div className="col-md-6">
            <div className="SwFormGroup">
              <label className='SwFormLabel'>
                Service End Date
                <span className="Required">*</span>
              </label>
              <AntDDatePicker
                value={this.state.date1 ? dayjs(this.state.date1) : null}
                onChange={this.onDateChange1}
                allowClear={false}
                disabled={!this.state.date}
                placeholder="End Date"
                disabledDate={(current) =>
                  this.state.date &&
                  current &&
                  current < dayjs(this.state.date)
                }
              />
              <span className="SwTextDanger SwTextSmall">
                {this.state.date1Error}
              </span>
            </div>
          </div>
        </div>

      </>
    );
  }
}

export default ParkingSlots;
